import SemverCompare from 'semver-compare';
import UAParser from 'ua-parser-js';
import isString from 'lodash/isString';

const compareVersions = (a, b) => {
  if (isString(a)) {
    return SemverCompare(a, b) <= 0;
  }

  return a <= parseInt(b, 10);
};

class DetectionManager {
  constructor() {
    this.parser = new UAParser();
    this.os = this.parser.getOS();
    this.browser = this.parser.getBrowser();
    this.device = this.parser.getDevice();
    this.isPhone = this.checkPhone();
    this.isTablet = this.checkTablet();
    this.isAndroid = this.checkAndroid();
    this.isIOS = this.checkIOS();
    this.supported = {
      Android: {
        minVersion: '4.1',
        browsers: [
          {
            browser: 'chrome',
            minVersion: 58,
          },
        ],
      },
      iOS: {
        minVersion: 12,
        browsers: [
          {
            browser: 'mobile safari',
            minVersion: 12,
          },
        ],
      },
      'Mac OS': {
        minVersion: 10,
        browsers: [
          {
            browser: 'chrome',
            minVersion: 58,
          },
          {
            browser: 'firefox',
            minVersion: 56,
          },
          {
            browser: 'safari',
            minVersion: 11,
          },
          {
            browser: 'opera',
            minVersion: 58,
          },
          {
            browser: 'qqbrowserlite',
            minVersion: 1,
          },
        ],
      },
      Windows: {
        minVersion: 7,
        browsers: [
          {
            browser: 'chrome',
            minVersion: 58,
          },
          {
            browser: 'firefox',
            minVersion: 56,
          },
          {
            browser: 'opera',
            minVersion: 58,
          },
          {
            browser: 'qqbrowserlite',
            minVersion: 1,
          },
        ],
      },
    }[this.os.name];

    this.isSupported = this.checkSupported();
  }

  checkSupported() {
    if (!this.supported || this.isPhone) {
      return false;
    }

    const {browsers, minVersion} = this.supported;
    const {name: browserName, version: browserVersion} = this.browser;
    const isOSVersionValid = compareVersions(minVersion, this.os.version);
    if (!isOSVersionValid) {
      return false;
    }

    return browsers.some(({browser, minVersion: minBrowserVersion}) =>
      browser.toLowerCase() === browserName.toLowerCase()
        && compareVersions(minBrowserVersion, browserVersion));
  }

  checkPhone() {
    return this.device.type === 'mobile';
  }

  checkTablet() {
    return this.device.type === 'tablet';
  }

  checkAndroid() {
    const {name} = this.os;

    return name && name.toLowerCase() === 'android';
  }

  checkIOS() {
    const {name} = this.os;

    return name && name.toLowerCase() === 'ios';
  }
}

export const Detection = new DetectionManager();
